import React from 'react';
import { type PropsWithChildren, useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export function FocusContainerPlugin({
  className,
  children,
}: PropsWithChildren<{ className: string }>) {
  const [editor] = useLexicalComposerContext();

  const handleClick = useCallback(() => {
    editor.focus();
  }, [editor]);
  return (
    <div className={className} onClick={handleClick} tabIndex={-1}>
      {children}
    </div>
  );
}
